// import React, { Component } from "react";
// import DoctorBasicInfoView from "./DoctorBasicInfoView";

// export default class DoctorBasicInfoContainer extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       details: {}
//     };
//   }

//   render() {
//     const { details } = this.props;

//     return <>{details && <DoctorBasicInfoView details={details} />}</>;
//   }
// }

import React from "react";
import { Form, notification, Spin } from "antd";
import dateFormat from "dateformat";
import BasicInfoView from "./BasicInfoView";
import {
  verifyDoctor,
  getBasicSpecialities,
  getProfileDetails,
  updateProfileDetails
} from "../../../services";
import {
  history,
  strings,
  openNotificationWithIcon,
  getUser
} from "../../../helpers";
import ShowVerifyModal from "./ShowVerifyModal";
import ShowImageResultModal from "./ShowImageResultModal";

class DoctorBasicInfoContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      specialities: [],
      searchText: "",
      profileDetail: {},
      dob: null,
      isProcessing: false,
      openImageResultModal: false,
      openVerifyModal: false,
      doctorId: "",
      attachmentImageData: "",
      selectedReason: "Select",
      verified: false,
      showVerify: false,
      user: ""
    };
  }

  componentDidMount() {
    const { doctorId } = this.props;
    this.getSpecialities();
    if (doctorId) {
      this.getBasicInfo();
    }
    const data = getUser();
    const { user_accounts } = data;
    this.setState({ user: user_accounts[0], doctorId });
  }

  /**
   * @function getBasicInfo
   * @desc this function gets doctor basic info
   */
  getBasicInfo = async () => {
    const { doctorId } = this.props;
    let profileDetail = {};
    this.setState({ isProcessing: true });
    const profileDetailResponse = await getProfileDetails(doctorId);
    if (profileDetailResponse && profileDetailResponse.data.success) {
      profileDetail = profileDetailResponse.data.data;
    }
    this.setState({
      profileDetail,
      attachmentImageData: profileDetail.reg_photo_url,
      showVerify: profileDetail.verified,
      isProcessing: false
    });
  };

  /**
   * @function getSpecialties
   * @desc this function gets basic specialities
   */
  getSpecialities = () => {
    let specialities = [];
    getBasicSpecialities(this.state.searchText).then(response => {
      if (response?.data?.hits?.hits?.length > 0) {
        specialities = response.data.hits.hits.map(speciality => ({
          id: speciality._source.id,
          name: speciality._source.name
        }));
        this.setState({ specialities });
      }
    });
  };

  /**
   * @function handleSpecialitySearch
   * @param "name"
   * @desc this function handles speciality search input and sets state
   */
  handleSpecialitySearch = name => {
    if (name && name.length > 0) {
      this.setState({ searchText: name });
      this.getSpecialities();
    }
  };

  /**
   * @function updateSelectedDate
   * @param "dob"
   * @desc this function updates selected date for date of birth
   */
  updateSelectedDate = dob => {
    this.setState({ dob });
  };

  /**
   * @function handleSubmit
   * @param "e"
   * @desc this function handles final saving of basic info
   */
  handleSubmit = e => {
    e.preventDefault();
    const { doctorId } = this.props;
    const { dob, attachmentImageData } = this.state;
    this.props.form.validateFieldsAndScroll(async (err, value) => {
      if (!err) {
        const doctorDetail = {
          doctor_details: {
            id: doctorId,
            dob: dob ? dateFormat(dob, "dd-mm-yyyy") : null,
            name: value.name,
            country_code: value.countryCode || "91",
            phone_number: value.phoneNumber,
            speciality: value.speciality,
            exp: value.experience,
            gender: value.gender,
            patients_per_hour: value.patientsPerHour,
            bio: value.bio,
            reg_nbr: value.registrationNumber,
            reg_photo_url: attachmentImageData
          }
        };

        this.setState({ isProcessing: true });
        // update detail
        const response = await updateProfileDetails(doctorDetail);
        if (response && response.data.success) {
          notification.success({
            message: strings.ticket_detail_view.success,
            description: strings.profile.basicInfoSaveSuccess
          });
          this.getBasicInfo();
        }
        this.setState({ isProcessing: false });
      }
    });
  };

  /**
   * @function cancelImageResultModal
   * @desc it will dismiss the loader
   */
  cancelImageResultModal = () => {
    this.setState({ openImageResultModal: false });
  };

  /**
   * @function cancelImageResultModal
   * @desc it will dismiss the loader
   */
  cancelShowVerifyModal = () => {
    this.setState({ openVerifyModal: false });
  };

  /**
   * @function goToNextTab
   * @desc this function redirects user to education tab/ page
   */
  goToNextTab = () => {
    const { onlyDoctors } = this.props;
    if (onlyDoctors) return false;

    this.props.changeAccordinKey("2");
    const url = `/doctor-details/education/${this.props.doctorId}/${this.props.clinicId}/${this.props.doctorClinicId}`;
    history.push(url);
  };

  /**
   * @function showMedicalRegPhoto
   * @description it will show the image in popup
   */
  showMedicalRegPhoto = () => {
    this.setState({ openImageResultModal: true });
  };

  /**
   * @function showMedicalRegPhoto
   * @description it will show the image in popup
   */
  showVerifyModal = () => {
    const { profileDetail } = this.state;
    this.setState({ openVerifyModal: true });
    // if (
    //   profileDetail.reg_nbr !== "" &&
    //   profileDetail.reg_photo_url !== "" &&
    //   profileDetail.reg_nbr !== null &&
    //   profileDetail.reg_photo_url !== null &&
    //   profileDetail.reg_nbr !== undefined &&
    //   profileDetail.reg_photo_url !== undefined
    // ) {
    //   this.setState({ openVerifyModal: true });
    // } else {
    //   openNotificationWithIcon(
    //     "error",
    //     `${strings.ticket_detail_view.ToProvide}`,
    //     `${strings.ticket_detail_view.MedicalLicenseNumber}`
    //   );
    // }
  };

  /**
   * @func  onStatusFilter
   * @param status
   * @description it will set the data of reason accordingly
   */
  onStatusFilter = status => {
    this.setState({ selectedReason: status.key });
  };

  /**
   * @function onChangeRadioButton
   * @param value
   * @description changes the status of verify
   */
  onChangeRadioButton = value => {
    this.setState({ verified: value.target.value });
  };

  /**
   * @function verifyDoctor
   * @description it will verify the doctor
   */
  verifyDoctor = () => {
    const { selectedReason, showVerify, doctorId } = this.state;

    this.setState({ isProcessing: true });
    if (!showVerify) {
      if (selectedReason === "Select") {
        this.setState({ isProcessing: false });
        return openNotificationWithIcon(
          "error",
          `${strings.ticket_detail_view.DoctorVerification}`,
          `${strings.ticket_detail_view.PleaseReason}`
        );
      }
    }
    let data = {};
    if (!showVerify) {
      data = {
        verify_details: {
          verify_status: true,
          verification_reason: `${selectedReason}`
        }
      };
    } else {
      data = {
        verify_details: {
          verify_status: false,
          verification_reason: `${selectedReason}`
        }
      };
    }
    this.cancelShowVerifyModal();
    verifyDoctor(doctorId, data)
      .then(response => {
        this.setState({ isProcessing: false });
        if (response.data.success) {
          openNotificationWithIcon(
            "success",
            `${strings.ticket_detail_view.DoctorVerification}`,
            !showVerify
              ? `${strings.ticket_detail_view.DoctorVerified}`
              : `${strings.ticket_detail_view.DoctorUnverified}`
          );
          this.getBasicInfo();
        } else if (response.data.errors) {
          openNotificationWithIcon(
            "error",
            `${strings.ticket_detail_view.DoctorVerification}`,
            `${response.data.errors.title}`
          );
        }
      })
      .catch(() => {
        this.setState({ isProcessing: false });
      });
  };

  render() {
    const { form } = this.props;
    const {
      specialities,
      profileDetail,
      dob,
      isProcessing,
      openImageResultModal,
      attachmentImageData,
      openVerifyModal,
      selectedReason,
      verified,
      user,
      showVerify
    } = this.state;

    return (
      <Spin spinning={isProcessing}>
        <BasicInfoView
          showVerify={showVerify}
          user={user}
          showMedicalRegPhoto={this.showMedicalRegPhoto}
          showVerifyModal={this.showVerifyModal}
          form={form}
          handleSubmit={this.handleSubmit}
          specialities={specialities}
          handleSpecialitySearch={this.handleSpecialitySearch}
          profileDetail={profileDetail}
          dob={dob}
          updateSelectedDate={this.updateSelectedDate}
          goToNextTab={this.goToNextTab}
        />
        <ShowImageResultModal
          attachmentImageData={attachmentImageData}
          openImageResultModal={openImageResultModal}
          cancelImageResultModal={this.cancelImageResultModal}
        />
        <ShowVerifyModal
          showVerify={showVerify}
          verifyDoctor={this.verifyDoctor}
          onChangeRadioButton={this.onChangeRadioButton}
          verified={verified}
          onStatusFilter={this.onStatusFilter}
          selectedReason={selectedReason}
          attachmentImageData={attachmentImageData}
          openVerifyModal={openVerifyModal}
          cancelShowVerifyModal={this.cancelShowVerifyModal}
        />
      </Spin>
    );
  }
}

const BasicInfoForm = Form.create()(DoctorBasicInfoContainer);
export default BasicInfoForm;
